"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrialEndModal = void 0;
var trial_extension_3_svg_1 = __importDefault(require("@ClientAssets/icons/trial-extension-3.svg"));
var trial_extension_1_svg_1 = __importDefault(require("@ClientAssets/icons/trial-extension-1.svg"));
var trial_extension_2_svg_1 = __importDefault(require("@ClientAssets/icons/trial-extension-2.svg"));
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var ModalComponent_1 = require("@CommonFrontend/Modal/ModalComponent");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var moment_1 = __importDefault(require("moment"));
var axios_1 = __importDefault(require("axios"));
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var kaleidoscope_4 = require("@qwilr/kaleidoscope");
var AnimationLength;
(function (AnimationLength) {
    AnimationLength[AnimationLength["Idle"] = 2050] = "Idle";
    AnimationLength[AnimationLength["LoadingDelay"] = 1280] = "LoadingDelay";
    AnimationLength[AnimationLength["LoadingCycle"] = 2416] = "LoadingCycle";
})(AnimationLength || (AnimationLength = {}));
exports.default = (function (modal, initSubscription, account, apiBaseUrl, publicApiBaseUrl, trial, telemetry, rootDataStore) {
    var logout = function () {
        window.location = "".concat(publicApiBaseUrl, "/logout");
    };
    modal.showSimpleModal({
        isEscapable: false,
        containerClassName: "modal-container--behind-overlays",
        body: (react_1.default.createElement(TrialEndModal, { browsePlans: initSubscription.init, extendTrial: function () { return callExtendTrialAPI(apiBaseUrl, account, trial, rootDataStore.getAccountDataStore()); }, canExtendTrial: !account.trialExtensionsCount && account.plan.displayName === "Trial", callback: function () {
                modal.closeAnyModals();
            }, logout: logout, telemetry: telemetry })),
    });
});
var callExtendTrialAPI = function (apiBaseUrl, account, trial, accountDataStore) { return __awaiter(void 0, void 0, Promise, function () {
    var response, timeTrial, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4, axios_1.default.post("".concat(apiBaseUrl, "/accounts/").concat(account._id, "/plan/extend-trial"), {}, { withCredentials: true })];
            case 1:
                response = _a.sent();
                timeTrial = response.data.timeTrial;
                trial.trialStore.setEndDate(timeTrial.endDate);
                accountDataStore.setStatus(response.data.accountStatus);
                return [2, timeTrial];
            case 2:
                error_1 = _a.sent();
                throw new Error("Something went wrong. Please try again.");
            case 3: return [2];
        }
    });
}); };
var TrialModalState;
(function (TrialModalState) {
    TrialModalState["Idle"] = "idle";
    TrialModalState["Loading"] = "loading";
    TrialModalState["Success"] = "success";
})(TrialModalState || (TrialModalState = {}));
var Icon = {
    Idle: trial_extension_1_svg_1.default,
    Loading: trial_extension_2_svg_1.default,
    Success: trial_extension_3_svg_1.default,
};
var TrialEndModal = (function (_super) {
    __extends(TrialEndModal, _super);
    function TrialEndModal() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.modalState = TrialModalState.Idle;
        _this.idleAnimationStartTime = NaN;
        _this.loadingAnimationStartTime = NaN;
        _this.onHelpClick = function () {
            if (window.Beacon) {
                window.Beacon("open");
                window.Beacon("navigate", "/ask/message/");
            }
        };
        return _this;
    }
    TrialEndModal.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "trial-end-modal trial-end-modal--".concat(this.modalState) },
            react_1.default.createElement("div", { className: "trial-end-modal__icon" },
                react_1.default.createElement(kaleidoscope_1.SVG, { src: this.src, onLoad: this.onLoad })),
            react_1.default.createElement("div", { className: "trial-end-modal__hidden-icon" }, Object.values(Icon).map(function (icon) { return (react_1.default.createElement(kaleidoscope_1.SVG, { key: icon, src: icon })); })),
            this.body));
    };
    Object.defineProperty(TrialEndModal.prototype, "body", {
        get: function () {
            if (!this.props.canExtendTrial) {
                return this.noTrialExtensionBody;
            }
            else if (this.modalState !== TrialModalState.Success) {
                return this.trialExtensionBody;
            }
            else {
                return this.extendedTrialBody;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TrialEndModal.prototype, "noTrialExtensionBody", {
        get: function () {
            var _this = this;
            this.props.telemetry.trackOnly("Trial Ended Modal Viewed", { trial_end_modal_type: "cannot_extend_trial" });
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(ModalComponent_1.StandardModalHeader, { title: "Thanks for trying us out!", explainer: react_1.default.createElement(react_1.default.Fragment, null,
                        "To access your account and Qwilr Pages, you'll need to subscribe to a plan. Have questions?",
                        " ",
                        react_1.default.createElement(kaleidoscope_2.Link, { onClick: function () {
                                _this.props.telemetry.trackOnly("Trial Ended Modal Contact Link Clicked");
                                _this.onHelpClick();
                            } }, "Get in touch")) }),
                react_1.default.createElement("div", { className: "actions two-actions center" },
                    react_1.default.createElement(kaleidoscope_2.Button, { width: "normal", type: kaleidoscope_2.ButtonType.Secondary, size: kaleidoscope_2.ButtonSize.Large, onClick: function () {
                            _this.props.telemetry.trackOnly("Trial Ended Modal Log Out Clicked");
                            _this.props.logout();
                        } }, "Log out"),
                    react_1.default.createElement(kaleidoscope_2.Button, { width: "normal", size: kaleidoscope_2.ButtonSize.Large, onClick: function () {
                            _this.props.telemetry.trackOnly("Trial Ended Modal Browse Plans Clicked");
                            _this.props.browsePlans();
                        } }, "Browse plans"))));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TrialEndModal.prototype, "trialExtensionBody", {
        get: function () {
            var _this = this;
            this.props.telemetry.trackOnly("Trial Ended Modal Viewed", { trial_end_modal_type: "can_extend_trial" });
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(ModalComponent_1.StandardModalHeader, { title: "Your trial has ended", explainer: react_1.default.createElement(react_1.default.Fragment, null,
                        "To edit and access your account, you'll need to extend your trial or subscribe to a plan. Your Qwilr Pages will be available for 30 days. Have questions? ",
                        react_1.default.createElement(kaleidoscope_2.Link, { onClick: this.onHelpClick }, "Get in touch")) }),
                react_1.default.createElement("div", { className: "actions two-actions center" },
                    react_1.default.createElement(kaleidoscope_2.Button, { type: kaleidoscope_2.ButtonType.Secondary, width: "normal", size: kaleidoscope_2.ButtonSize.Large, onClick: function () {
                            _this.props.telemetry.trackOnly("Trial Ended Modal Browse Plans Clicked");
                            _this.props.browsePlans();
                        } }, "Browse plans"),
                    react_1.default.createElement(kaleidoscope_3.ErrorTooltip, { size: kaleidoscope_4.TooltipSize.Large, content: this.error || "", renderTooltip: !!this.error && !!this.error.length },
                        react_1.default.createElement(kaleidoscope_2.Button, { type: kaleidoscope_2.ButtonType.Primary, width: "normal", size: kaleidoscope_2.ButtonSize.Large, onClick: function () {
                                _this.props.telemetry.trackOnly("Trial Ended Modal Extend Trial Clicked");
                                return _this.extendTrial();
                            } }, "Extend my trial")))));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TrialEndModal.prototype, "extendedTrialBody", {
        get: function () {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(ModalComponent_1.StandardModalHeader, { title: "Your trial has been extended", explainer: react_1.default.createElement(react_1.default.Fragment, null,
                        "Keep editing and using Qwilr for another 7 days. Your trial will expire on",
                        " ",
                        react_1.default.createElement("b", null, (0, moment_1.default)(this.newDate).format("D MMMM YYYY")),
                        ".") }),
                react_1.default.createElement("div", { className: "actions center" },
                    react_1.default.createElement(kaleidoscope_2.Button, { width: "normal", size: kaleidoscope_2.ButtonSize.Large, onClick: this.closeModal }, "Okay, got it"))));
        },
        enumerable: false,
        configurable: true
    });
    TrialEndModal.prototype.closeModal = function () {
        return this.props.callback();
    };
    TrialEndModal.prototype.extendTrial = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_2, startCycle;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.modalState !== TrialModalState.Idle) {
                            return [2];
                        }
                        this.error = undefined;
                        return [4, waitFor(Math.min(AnimationLength.Idle, this.idleAnimationStartTime + AnimationLength.Idle - Date.now()))];
                    case 1:
                        _a.sent();
                        this.setModalState(TrialModalState.Loading);
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4, Promise.all([
                                this.doExtendTrial(),
                                waitFor(Math.min(AnimationLength.LoadingDelay, this.idleAnimationStartTime + AnimationLength.LoadingDelay - Date.now())),
                            ])];
                    case 3:
                        _a.sent();
                        return [3, 5];
                    case 4:
                        error_2 = _a.sent();
                        this.setModalState(TrialModalState.Idle);
                        this.error = error_2.message;
                        throw error_2;
                    case 5:
                        startCycle = Date.now() - this.loadingAnimationStartTime + AnimationLength.LoadingDelay;
                        return [4, waitFor(AnimationLength.LoadingCycle - (startCycle % AnimationLength.LoadingCycle))];
                    case 6:
                        _a.sent();
                        this.setModalState(TrialModalState.Success);
                        return [2];
                }
            });
        });
    };
    TrialEndModal.prototype.setModalState = function (modalState) {
        this.modalState = modalState;
    };
    TrialEndModal.prototype.onLoad = function (src) {
        switch (src) {
            case Icon.Idle: {
                this.idleAnimationStartTime = Date.now();
                break;
            }
            case Icon.Loading: {
                this.loadingAnimationStartTime = Date.now();
                break;
            }
        }
    };
    Object.defineProperty(TrialEndModal.prototype, "src", {
        get: function () {
            var _a;
            return (_a = {},
                _a[TrialModalState.Idle] = Icon.Idle,
                _a[TrialModalState.Loading] = Icon.Loading,
                _a[TrialModalState.Success] = Icon.Success,
                _a)[this.modalState];
        },
        enumerable: false,
        configurable: true
    });
    TrialEndModal.prototype.doExtendTrial = function () {
        return __awaiter(this, void 0, void 0, function () {
            var timeTrial;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.props.extendTrial()];
                    case 1:
                        timeTrial = _a.sent();
                        (0, mobx_1.runInAction)(function () {
                            _this.newDate = new Date(timeTrial.endDate);
                        });
                        return [2];
                }
            });
        });
    };
    var _a, _b, _c, _d, _e;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], TrialEndModal.prototype, "modalState", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Number)
    ], TrialEndModal.prototype, "idleAnimationStartTime", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Number)
    ], TrialEndModal.prototype, "loadingAnimationStartTime", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], TrialEndModal.prototype, "newDate", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], TrialEndModal.prototype, "error", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_b = typeof JSX !== "undefined" && JSX.Element) === "function" ? _b : Object),
        __metadata("design:paramtypes", [])
    ], TrialEndModal.prototype, "body", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_c = typeof JSX !== "undefined" && JSX.Element) === "function" ? _c : Object),
        __metadata("design:paramtypes", [])
    ], TrialEndModal.prototype, "noTrialExtensionBody", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_d = typeof JSX !== "undefined" && JSX.Element) === "function" ? _d : Object),
        __metadata("design:paramtypes", [])
    ], TrialEndModal.prototype, "trialExtensionBody", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", typeof (_e = typeof JSX !== "undefined" && JSX.Element) === "function" ? _e : Object),
        __metadata("design:paramtypes", [])
    ], TrialEndModal.prototype, "extendedTrialBody", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TrialEndModal.prototype, "closeModal", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], TrialEndModal.prototype, "extendTrial", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], TrialEndModal.prototype, "setModalState", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], TrialEndModal.prototype, "onLoad", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], TrialEndModal.prototype, "src", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], TrialEndModal.prototype, "doExtendTrial", null);
    TrialEndModal = __decorate([
        mobx_react_1.observer
    ], TrialEndModal);
    return TrialEndModal;
}(react_1.default.Component));
exports.TrialEndModal = TrialEndModal;
var waitFor = function (time) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, new Promise(function (resolve) {
                    setTimeout(resolve, Math.max(0, time));
                })];
            case 1:
                _a.sent();
                return [2];
        }
    });
}); };
